export enum Races {
  WHITE = "white",
  COLOURED = "coloured",
  INDIAN = "indian",
  BLACK = "black"
}

export enum CategoryBreakdownTitles {
  YEAR = "Year",
  FUNDS = "Total funds allocated",
  STUDENTS = "Total students funded",
  PERCENTAGES = "Total percentage of funding per race",
  PERCENTAGES_HEADING = "Total percentage of funding per race",
  TOTAL = "Total",
  FILTER_DEFAULT = "All",
  STUDENTS_LABEL = "Students",
  USED = "Amount used",
  FUND_ALLOCATION = "Fund allocation per university",
  CHART_TYPE = "bar"
}

export enum AdminColours {
  SHADE_1 = "#584ee4",
  SHADE_2 = "#9b94ff",
  SHADE_3 = "#39339B",
  SHADE_4 = "#25225E",
  DEFAULT = "#FFFFFF"
}

export enum UkukhulaColours {
  SHADE_1 = "#2E7A7C",
  SHADE_2 = "#06D6A0",
  SHADE_3 = "#22A2A7",
  SHADE_4 = "#2C5052",
  DEFAULT = "#FFFFFF"
}

export enum BBDColours {
  SHADE_1 = "#c52828",
  SHADE_2 = "#e63939",
  SHADE_3 = "#ea5b5b",
  SHADE_4 = "#8f1414",
  DEFAULT = "#FFFFFF"
}